import { ReactElement } from 'react';
import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';

import withShow from 'ia-react-core/~/hocs/withShow';
import compose from '../../../utils/components/_compose';
import withFormState from '../../../hocs/form/_withFormState';

import withControl from './withControl';
import UploadControl, { UploadControlProps } from './UploadControl';

export * from './UploadControl';

export default compose<<Value =(
File | string)[], StateValue = File[]>(
    props: WithBehaviorsProps<UploadControlProps<Value, StateValue>>
  ) => ReactElement<WithBehaviorsProps<UploadControlProps<Value, StateValue>>>>(
  withBehaviors,
  withShow,
  withFormState,
  withControl,
  )(UploadControl);
